import { Status } from "src/app/core/framework/default.model";

export class Constants {

  // STORAGE KEYS
  static dataInicioMilliStorageKey = 'dataInicioStorageKey';
  static dataFimMilliStorageKey = 'dataFimStorageKey';
  static idSalaDeMedicacaoSelecionadaStorageKey = 'idSalaDeMedicacaoSelecionadaStorageKey';
  static rotaColetaExibirGraficoGeracaoDeRota = 'rotaColetaExibirGraficoGeracaoDeRota';
  static statusAgendamentoFiltroIniciadoAtivo = 'statusAgendamentoFiltroIniciadoAtivo';
  static statusAgendamentoFiltroRealizadoAtivo = 'statusAgendamentoFiltroRealizadoAtivo';
  static statusAgendamentoFiltroFinalizadoAtivo = 'statusAgendamentoFiltroFinalizadoAtivo';
  static timelinePacienteOptionAgrupado = 'timelinePacienteOptionAgrupado';

  // AGENDAMENTO COLETA
  static calendarViewAgendamentoColetaStorageKey = 'calendarViewAgendamentoColetaStorageKey';
  static exibirMapaAgendamentoColetaStorageKey = 'exibirMapaAgendamentoColetaStorageKey';
  static configOrdenacaoAgendamentoColetaStorageKey = 'configOrdenacaoAgendamentoColetaStorageKey';
  static configAgendamentoMapaBaselayerStorageKey = 'configAgendamentoMapaBaselayerStorageKey';

  // SUMARIO & ATENDIMENTO PACIENTE
  static sumarioPctHistoricoTabSelStorageKey = 'sumarioPctHistoricoTabSelStorageKey';
  static fieldsetHistoricoAvaliacaoContraidoStorageKey = 'fieldsetHistoricoAvaliacaoContraidoStorageKey';
  static fichaAtendimentoSalaTagStorageKey = 'fichaAtendimentoSalaTagStorageKey';
  static rascunhoAvaliacaoAtendimentoSalaStorageKey = 'rascunhoAvaliacaoAtendimentoSalaStorageKey';

  // FARMACIA STORAGE KEYS
  static movimentacaoDeProdutoUnidadeOrigemStorageKey = 'movimentacaoDeProdutoUnidadeOrigemStorageKey';
  static movimentacaoDeProdutoUnidadeDestinoStorageKey = 'movimentacaoDeProdutoUnidadeDestinoStorageKey';

  // DASHBOARDS
  static dashExibirCarteiraDeCliente = 'dashExibirCarteiraDeCliente';
  static dashExibirHomecare = 'dashExibirHomecare';
  static dashExibirColeta = 'dashExibirColeta';
  static dashExibirSistema = 'dashExibirSistema';
  static dashExibirFarmacia = 'dashExibirFarmacia';

  // ASSISTENTE DE ROTA
  static tipoDeRotaParaAgendamento = 'tipoDeRotaParaAgendamento';
  static idDoultimoUsuarioSelecionadoParaAgendamento = 'idDoultimoUsuarioSelecionadoParaAgendamento';
  static dataMilliDaRotaParaAgendamento = 'dataMilliDaRotaParaAgendamento';

  // ALTURA DO HEADER + RODAPE
  static alturaHeaderERodape = 225;

  // ffcc80 64A1DE c7f7c7 1400E0 FE8E7B
  static corPreAgendado: string = '#ffee58'; // #FFB68C
  static corAgendado   : string = '#ffcc80';
  static corPendente   : string = '#ff6d2e'; // #FF6787
  static corIniciado   : string = '#5EEBE7';
  static corRealizado  : string = '#54F555'; // #97ED97
  static corFinalizado : string = '#7163ff'; // # D18BC0
  static corCancelado  : string = '#757575';

  static chartColors = {
    red: 'rgb(255, 99, 132)',
    redTransparent: 'rgb(255, 99, 132, 0.2)',
    orange: 'rgb(255, 159, 64)',
    orangeTransparent: 'rgb(255, 159, 64, 0.2)',
    yellow: 'rgb(255, 205, 86)',
    yellowTransparent: 'rgb(255, 205, 86, 0.2)',
    green: 'rgb(75, 192, 192)',
    greenTransparent: 'rgb(75, 192, 192, 0.2)',
    blue: 'rgb(54, 162, 235)',
    blueTransparent: 'rgb(54, 162, 235, 0.2)',
    purple: 'rgb(153, 102, 255)',
    purpleTransparent: 'rgb(153, 102, 255, 0.2)',
    gray: 'rgb(201, 203, 207)',
    grayTransparent: 'rgb(201, 203, 207, 0.2)',
    pink: 'rgb(255,99,132)'
  };

  static chartColorLaranja = '#fdae6b';

  static opcoesStatus = [{label: 'Ativo', value: Status.ATIVO},
                         {label: 'Inativo', value: Status.INATIVO}];

  static versaoWebUiStorageKey = 'versaoWebUiStorageKey';
}
